import React, { useContext, useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { renderToStaticMarkup } from 'react-dom/server';
import axios from 'axios';
import { useHistory } from 'react-router-dom';
import SubHeader from '../../commonComponents/pageLayout/SubHeader';
import translate from '../../commonComponents/translate';
import Title from '../../commonComponents/Title';
import ContentContainer from '../../commonComponents/pageLayout/ContentContainer';
import CountryProp from '../../commonComponents/forms/Address/CountryProp';
import TenantProp from '../../commonComponents/propTypes/tenantProp';
import SessionProp from './propTypes/sessionProp';
import AcademySessionToggle from './detail/AcademySessionToggle';
import SessionItemDetail from './detail/SessionItemDetail';
import HardSkillProp from '../challenges/propTypes/hardSkillProp';
import CertificateDisplay from '../academy/details/CertificateDisplay';
import CertificateProp from '../academy/propTypes/certificateProp';
import AppProductProp from '../profile/propTypes/appProductProp';
import PrintModal from '../profile/mainPanel/print/PrintModal';
import StripeCardProp from '../profile/propTypes/StripeCardProp';
import EnrollModal from '../academy/EnrollModal';
import List from '../../commonComponents/lists/List';
import AcademyCourse from '../academy/list/AcademyCourse';
import MetaContext from '../../contextProviders/MetaContext';
import LoggedUserContext from '../../contextProviders/LoggedUserContext';
import {
  IN_APP_PRODUCT_TYPE,
  PAYMENT_METHOD,
} from '../../services/utilityFunctions';
import JourneyItem from '../journey/JourneyItem';
import FinishedSessionModal from './modal/FinishedSessionModal';
import WebinarDocuments from './detail/WebinarDocuments';
import ProductProp from '../shop/propTypes/productProp';
import ShippingProviderProp from '../shop/propTypes/shippingProviderProp';
import OrganizationProp from '../../commonComponents/propTypes/organizationProp';
import CourseItem from './components/CourseItem';
import Carousel from '../../commonComponents/carousel/Carousel';
import CourseProp from '../academy/propTypes/courseProp';
import CourseContentDetails from '../academy/details/CourseContentDetails';
import Loader from '../../services/loader';
import ScormDetail from '../academy/details/ScormDetail';
import BiggerImageModal from '../../commonComponents/modal/BiggerImageModal';
import { useModal } from '../../services/customHooks';
import Notifications from '../../services/notifications';
import GenericModal from '../../commonComponents/modal/GenericModal';
import CurrencyProp from '../profile/propTypes/currencyProp';
import AcademyPaymentModal from '../../commonComponents/modal/AcademyPaymentModal';
import VatTypesProp from '../../commonComponents/forms/Address/VatTypesProp';
import ShopModalOrderComplete from '../shop/shopItems/ShopModalOrderComplete';
import WebinarSection from './detail/WebinarSection';
import ClassroomSection from './classroom/ClassroomSection';
import { SESSION_TYPE } from './propTypes/sessionUtils';
import ContentInacessibleModal from '../../commonComponents/modal/ContentInacessibleModal';

function SessionDetails(props) {
  const {
    t,
    directSellingActive,
    countries,
    sessions: session,
    ownerId,
    hardSkills,
    languages,
    certificate,
    appProducts,
    cards,
    products,
    shippingProviders,
    organization,
    _csrf,
    courses,
    verifyParticipation,
    enroll,
    currencies,
    orderId,
    redirect_status,
    payment_intent,
    open,
    tenant,
    vatTypes,
    isFromMySessionsPage,
  } = props;
  const [sessions, setSessions] = useState(session);
  const [showEnrollModal, setShowEnrollModal] = useState(
    !!(orderId && redirect_status && payment_intent) || !!open,
  );
  const hideModal = () => setShowEnrollModal(false);

  const sessionRef = useRef(null);
  const { meta } = useContext(MetaContext);
  const { loggedUser } = useContext(LoggedUserContext);
  const userIdLogged = loggedUser && loggedUser._id ? loggedUser._id : null;
  const handleRefreshSession = updatedSession => {
    sessionRef.current.updateSession(updatedSession);
  };
  useEffect(() => setSessions(sessions), [sessions]);

  const [showContentInacessibleModal, setShowContentInacessibleModal] =
    useModal({
      show: false,
      data: null,
    });

  const handleEnrollModal = () => {
    if (session.isContentAccessible) {
      setShowEnrollModal(true);
    } else {
      setShowContentInacessibleModal({ show: true, data: null });
    }
  };

  const [showPrintModal, setShowPrintModal] = useState(false);
  const [showEmailModal, setShowEmailModal] = useState(false);

  const columnsCourse = [
    {
      field: 'name',
      textAlign: 'center',
      template: item =>
        renderToStaticMarkup(
          <AcademyCourse
            t={t}
            meta={meta}
            loggedUser={loggedUser}
            course={item}
            showEnroll={false}
            showProgress={!item.isFromExternalProvider}
            showModules={!item.isFromExternalProvider}
            languages={languages}
            sessionId={session._id}
          />,
        ),
    },
  ];

  const columnsJourney = [
    {
      field: 'name',
      textAlign: 'center',
      template: item =>
        renderToStaticMarkup(
          <JourneyItem
            t={t}
            journey={item}
            languages={languages}
            sessionId={session._id}
          />,
        ),
    },
  ];
  const itemToPay = {
    name: sessions.name,
    userPromotionPrice: sessions.userPromotionsPrice,
    userPrice: sessions.userPrice,
    _id: sessions._id,
    image: sessions.image,
    mode: sessions.mode,
  };
  const typeOfItem = {
    field: 'sessions',
    fieldId: 'session',
  };

  const [showOrderSuccessModal, setShowOrderSuccessModal] = useModal({
    show: false,
    data: null,
  });
  const browserHistory = useHistory();
  const handleReload = () => {
    browserHistory.replace(`${window.location.pathname}`);
    browserHistory.go(0);
  };
  const handleSuccessModal = (paymentMethod, targetEmails) => {
    setShowEnrollModal(false);
    let urlGoBack = '/academy/sessions';
    let urlGoToOrder = '/shop/academy/order';
    let message =
      paymentMethod === PAYMENT_METHOD.PAID_BY_COMPANY
        ? t('academy.modal.success.paid_by_company', t('session'))
        : t('academy.modal.success.bankTransfer', t('session'));

    const isUnlocked =
      paymentMethod === PAYMENT_METHOD.CREDIT_CARD ||
      paymentMethod === PAYMENT_METHOD.BANCONTACT ||
      paymentMethod === PAYMENT_METHOD.PAYPAL ||
      redirect_status === 'succeeded' ||
      session.contentAvailableBeforePayment;
    if (isUnlocked) {
      message = t('academy.modal.success.order', t('session'));
      urlGoBack = null;
      urlGoToOrder = null;
    }
    if (!targetEmails?.includes(loggedUser.email)) {
      message = t('academy.modal.success.orderParticipants', t('session'));
    }
    setShowOrderSuccessModal({
      show: true,
      data: {
        urlGoBack,
        urlGoToOrder,
        modalMessage: message,
        onCloseModal: isUnlocked ? handleReload : () => {},
        buttonMessage: isUnlocked ? t('ok') : null,
        showBack: !isUnlocked,
      },
    });
  };

  const isFinished = () => {
    if (sessions.userStatus !== 'finished') {
      return (
        <AcademyPaymentModal
          item={itemToPay}
          typeOfItem={typeOfItem}
          onClose={hideModal}
          cards={cards.data}
          currencies={currencies}
          countries={countries}
          orderId={orderId}
          redirectStatus={redirect_status}
          paymentIntent={payment_intent}
          tenant={tenant}
          vatTypes={vatTypes}
          openSuccessModal={handleSuccessModal}
        />
      );
    }
    return (
      <FinishedSessionModal
        name={sessions.name}
        onClose={() => setShowEnrollModal(false)}
      />
    );
  };
  const sessionIsFinished = sessions.userStatus === 'finished';

  /** Is Trainer */
  // Loader
  const loader = useRef(new Loader('#courseSelected'));
  const [isLoading, setLoading] = useState(false);
  useEffect(() => {
    if (loader.current) {
      if (isLoading) {
        loader.current.show();
      } else {
        loader.current.hide();
      }
    }
  }, [isLoading]);

  const isTrainer = userIdLogged === sessions?.trainer?._id;

  /* owner, trainer and host do not need to subscribe or enroll */
  const doesNotNeedSubscription =
    isTrainer ||
    userIdLogged === sessions?.owner ||
    userIdLogged === sessions?.host?._id;

  /* owner, trainer and host can see participant list */
  const canSeeParticipants = doesNotNeedSubscription;

  // Course id from selection
  const [courseSelected, setCourseSelected] = useState(null);
  const handleCourseSelection = courseId => {
    // Do nothing if the course was already selected
    if (courseId !== courseSelected) {
      setLoading(true);
      setCourseSelected(courseId);
    }
  };
  // From all courses, get the ones in session
  const sessionCourses = courses.filter(
    c => c._id === sessions.courses.find(sc => sc === c._id),
  );
  const carouselItems = () =>
    sessionCourses.map(c => (
      <div className="col-lg-4 col-6" key={c._id}>
        <CourseItem
          t={t}
          course={c}
          onCourseSelected={handleCourseSelection}
          isFromSession
        />
      </div>
    ));
  // Course Detail from api request
  const [course, setCourse] = useState(null);
  // GET : Course Detail
  const getCourseDetails = () => {
    axios
      .get(
        `/api/academy/course/${courseSelected}?sessionContext=${session._id}`,
        {
          params: { populate: ['modules', 'survey'], session: session._id },
          headers: {
            'Accept-Version': '1.0.0',
            'X-Gamification-API': 'Games',
          },
        },
      )
      .then(({ data: response }) => {
        setCourse(response.data);
        setLoading(false);
      })
      .catch(err => {
        Notifications.showErrorFromRequest(err, 'error_fetchCourse');
        setLoading(false);
      });
  };

  // Run when user change course
  useEffect(() => {
    // make sure that trainer select course before making the request
    if (courseSelected) {
      getCourseDetails();
    }
  }, [courseSelected]);

  /** Handle Modal QR */
  const [qrBiggerModal, showQRBiggerModal] = useModal({
    show: false,
    data: null,
  });
  const handleQRModal = link => {
    showQRBiggerModal({ show: true, data: link });
  };

  /** VERIFY PARTICIPATION */
  // Handle Modal from Participation
  const [verifyModal, showVerifyModal] = useModal({ show: false, data: null });

  const handleVerifyParticipation = () => {
    axios
      .put(
        `/api/access-session/${sessions._id}/confirm-participation`,
        {},
        {
          headers: {
            'Accept-Version': '1.0.0',
            'X-Gamification-API': 'Games',
            'X-CSRF-Token': _csrf,
            _csrf,
          },
        },
      )
      .then(() => {
        showVerifyModal({
          show: true,
          data: {
            info: t('sessionDetails.verifyParticipation'),
            success: true,
          },
        });
      })
      .catch(err => {
        console.error('Err', err);
        showVerifyModal({
          show: true,
          data: { info: t(err.response.data.error), success: false },
        });
        Notifications.showErrorFromRequest(err, 'ERROR_UNKNOWN');
      });
  };
  useEffect(() => {
    if (verifyParticipation) {
      handleVerifyParticipation();
    }
    if (enroll && sessions.purchaseStatus === 'unpaid') {
      handleEnrollModal();
    }
  }, []);

  const sessionTrainer =
    (session && session.trainer && session.trainer._id) || null;

  const isUserInParticipants = sessions?.participants.find(
    u => u === loggedUser._id,
  );
  return (
    <>
      {showContentInacessibleModal.show && (
        <ContentInacessibleModal
          closeModal={() =>
            setShowContentInacessibleModal({ show: false, data: null })
          }
        />
      )}
      {showOrderSuccessModal.show && (
        <ShopModalOrderComplete
          closeModal={showOrderSuccessModal.data?.onCloseModal}
          urlGoToOrder={showOrderSuccessModal?.data?.urlGoToOrder}
          urlGoBack={showOrderSuccessModal?.data?.urlGoBack}
          goBackMessage={t('order.success.goBack', t('sessions'))}
          modalMessage={showOrderSuccessModal?.data?.modalMessage}
          confirmMessage={showOrderSuccessModal?.data?.buttonMessage}
          showBack={showOrderSuccessModal?.data?.showBack}
        />
      )}
      {verifyModal.show && (
        <GenericModal
          onClose={() => {
            // redirect to the "main" page without /verify/participation
            window.location = `/academy/sessions/${session.slug}`;
          }}
          title={verifyModal.data.success ? t('success') : t('error')}
          message={verifyModal.data.info}
          saveMessage={t('close')}
          modalId="verifyModal"
          titleClass={
            verifyModal.data.success ? 'success-title' : 'error-title'
          }
          containerClass="container-class"
        />
      )}
      {qrBiggerModal.show && (
        <BiggerImageModal
          size={256}
          value={qrBiggerModal.data}
          onClose={() => showQRBiggerModal({ show: false, data: null })}
        />
      )}
      {showPrintModal && (
        <PrintModal
          certificateId={certificate[0]._id}
          cards={cards.data}
          countries={countries}
          appProduct={appProducts.find(
            p => p.productType === IN_APP_PRODUCT_TYPE.CERTIFICATE,
          )}
          onClose={() => setShowPrintModal(false)}
        />
      )}
      {showEmailModal && (
        <EnrollModal
          itemType={IN_APP_PRODUCT_TYPE.DIGITAL_CERTIFICATE}
          itemId={certificate[0]._id}
          onClose={() => setShowEmailModal(false)}
        />
      )}
      {showEnrollModal && isFinished()}
      <Title title={t('sessionDetails_head_title')}>
        <ContentContainer>
          <SubHeader
            title={`${t('sessionDetails_title')}: ${sessions.name}`}
            breadcrumbs={[
              { link: '/academy', text: t('header_academy') },
              { link: '/academy/sessions', text: t('sessions_title') },
              { link: '', text: t('sessionDetails_head_title') },
            ]}
          />
          <div className="m-content">
            <div className="row full-page-container-with-subheader">
              <div className="col-lg-12 session-details-page">
                <SessionItemDetail
                  t={t}
                  ref={sessionRef}
                  onEnroll={handleEnrollModal}
                  onRefresh={handleRefreshSession}
                  sessions={sessions}
                  ownerId={ownerId}
                  languages={languages}
                  userId={userIdLogged}
                  _csrf={_csrf}
                />
                <AcademySessionToggle
                  session={sessions}
                  countries={countries}
                  ownerId={ownerId}
                  languages={languages}
                  hardSkills={hardSkills}
                  directSellingActive={directSellingActive}
                  products={products}
                  shippingProviders={shippingProviders}
                  organization={organization}
                  isFinished={sessionIsFinished}
                  currencies={currencies}
                  canSeeParticipants={canSeeParticipants}
                />
                {isTrainer && sessionCourses?.length > 0 && (
                  <div id="courseSelected">
                    <div className="course-more-information">
                      <h2>{t('access_session.detail.coursesInside')}</h2>
                      <div id="coursesCarousel">
                        <Carousel>{carouselItems()}</Carousel>
                      </div>
                    </div>
                    {course && (
                      <>
                        {!course.isFromExternalProvider && (
                          <CourseContentDetails
                            course={course}
                            cards={cards}
                            appProducts={appProducts}
                            countries={countries}
                            isFromSession
                            sessionId={session._id}
                            sessionTrainer={sessionTrainer}
                            sessionContext={session._id}
                          />
                        )}
                        {course.isFromExternalProvider && (
                          <ScormDetail
                            shouldScrollContent={false}
                            showEnrollOverlay={false}
                            course={course}
                            title={course.name}
                            url={course.provider.config.scorm.urlUser || ''}
                            cards={cards}
                            appProducts={appProducts}
                            countries={countries}
                            inJourney
                            isFromSession
                            sessionContext={session._id}
                          />
                        )}
                      </>
                    )}
                  </div>
                )}
                {sessions.type === SESSION_TYPE.CLASSROOM ? (
                  <ClassroomSection
                    session={sessions}
                    handleEnrollModal={handleEnrollModal}
                    handleQRModal={handleQRModal}
                  />
                ) : null}
                {sessions.type === SESSION_TYPE.WEBINAR ? (
                  <WebinarSection
                    t={t}
                    session={sessions}
                    handleEnrollModal={handleEnrollModal}
                    doesNotNeedSubscription={doesNotNeedSubscription}
                    handleQRModal={handleQRModal}
                    isUserInParticipants={isUserInParticipants}
                  />
                ) : null}
                {sessions.type === 'online' &&
                  (isUserInParticipants || doesNotNeedSubscription) && (
                    <>
                      {sessions?.documents?.length > 0 && (
                        <div className="col-12 no-padding">
                          <div className="m-portlet m-portlet--rounded m-portlet--rounded-force m-portlet--full-height">
                            <WebinarDocuments
                              t={t}
                              session={sessions}
                              documentColumnClass="col-2"
                            />
                          </div>
                        </div>
                      )}
                      {/** Journeys list for online sessions */}
                      {sessions.courses && sessions.courses.length !== 0 && (
                        <div className="row">
                          <div className="col-xl-12 col-lg-12">
                            <div className="courses-online_session">
                              <h3>{t('sessionDetails_courses')}</h3>
                              <List
                                id="courseList"
                                dataSourceURL={`/table/access-session/${session._id}/course/list`}
                                columns={columnsCourse}
                                query={{}}
                              />
                            </div>
                          </div>
                        </div>
                      )}
                      {/** Journeys list for online sessions */}
                      {sessions.journeys && sessions.journeys.length !== 0 && (
                        <div className="row">
                          <div className="col-xl-12 col-lg-12">
                            <div className="journeys-online_session">
                              <h3>{t('sessionDetails_journey')}</h3>
                              <List
                                id="journeyList"
                                dataSourceURL={`/table/access-session/${session._id}/journey/list`}
                                columns={columnsJourney}
                                query={{}}
                              />
                            </div>
                          </div>
                        </div>
                      )}
                    </>
                  )}
                {/** Certificate */}
                {certificate.length > 0 && (
                  <CertificateDisplay
                    certificate={certificate[0]}
                    session={sessions}
                    typeCertificate="session"
                    appProducts={appProducts}
                    onPrint={() => setShowPrintModal(true)}
                    onEmail={() => setShowEmailModal(true)}
                  />
                )}
              </div>
              {/** Button back to list */}
              <div className="row back-btn-container-sessions">
                <button
                  type="button"
                  className="btn default button-previous"
                  style={{ maxHeight: '40px' }}
                  onClick={() => {
                    window.location.href = isFromMySessionsPage
                      ? '/academy/my-sessions'
                      : '/academy/sessions?applyFilters=true';
                  }}
                >
                  <i className="fa fa-angle-left" />
                  {` ${t('back')}`}
                </button>
              </div>
            </div>
          </div>
        </ContentContainer>
      </Title>
    </>
  );
}

SessionDetails.propTypes = {
  t: PropTypes.func.isRequired,
  countries: PropTypes.arrayOf(PropTypes.shape(CountryProp.propType))
    .isRequired,
  sessions: PropTypes.shape(SessionProp.propType).isRequired,
  ownerId: PropTypes.string.isRequired,
  languages: PropTypes.arrayOf(PropTypes.shape(CountryProp.propType))
    .isRequired,
  hardSkills: PropTypes.arrayOf(PropTypes.shape(HardSkillProp.propType))
    .isRequired,
  appProducts: PropTypes.arrayOf(PropTypes.shape(AppProductProp.propType))
    .isRequired,
  cards: PropTypes.arrayOf(PropTypes.shape(StripeCardProp.propType)).isRequired,
  certificate: PropTypes.arrayOf(PropTypes.shape(CertificateProp.propType))
    .isRequired,
  directSellingActive: PropTypes.shape(TenantProp.propType),
  products: PropTypes.shape(ProductProp.propType).isRequired,
  shippingProviders: PropTypes.arrayOf(
    PropTypes.shape(ShippingProviderProp.propType),
  ).isRequired,
  organization: PropTypes.shape(OrganizationProp.propTypes).isRequired,
  _csrf: PropTypes.string.isRequired,
  courses: PropTypes.arrayOf(PropTypes.shape(CourseProp.propType)).isRequired,
  verifyParticipation: PropTypes.bool,
  enroll: PropTypes.bool,
  currencies: PropTypes.arrayOf(PropTypes.shape(CurrencyProp.propType))
    .isRequired,
  orderId: PropTypes.string,
  redirect_status: PropTypes.string,
  payment_intent: PropTypes.string,
  open: PropTypes.bool,
  tenant: PropTypes.shape(TenantProp.propType).isRequired,
  vatTypes: PropTypes.arrayOf(PropTypes.shape(VatTypesProp.propType))
    .isRequired,
  isFromMySessionsPage: PropTypes.bool,
};

SessionDetails.defaultProps = {
  directSellingActive: null,
  verifyParticipation: false,
  enroll: false,
  orderId: null,
  redirect_status: null,
  payment_intent: null,
  open: null,
  isFromMySessionsPage: false,
};

export default translate(SessionDetails);
